export const sortByPriority = (liveMatches, leagues) => {
  const list = Object.keys(liveMatches).sort(
    (a, b) => leagues[b]?.priority - leagues[a]?.priority
  );

  return list;
};
